import { toFixed } from "../filters/string/index";

//console.log(toFixed)

const toFixedPlugin = {
	install(Vue) {
		Vue.toFixed = toFixed;
	}
};

export default toFixedPlugin;
